import { useContext } from 'react'
import { ApplicationsContext, type ApplicationsContextValue } from '../contexts/ApplicationsContext'

export function useApplications(): ApplicationsContextValue {
  const context = useContext(ApplicationsContext)
  if (!context) {
    throw new Error('useApplications must be used within ApplicationsProvider')
  }
  return context
}
